import { render, staticRenderFns } from "./Artconfig.vue?vue&type=template&id=999c6538&"
import script from "./Artconfig.vue?vue&type=script&lang=js&"
export * from "./Artconfig.vue?vue&type=script&lang=js&"
import style0 from "./Artconfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports